import { updateProject, UpdateProjectPayload } from "@/lib/projects/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type UpdateProjectInput = {
  id: string;
  payload: UpdateProjectPayload;
};

export function useUpdateProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }: UpdateProjectInput) =>
      updateProject(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["applications"] });
    },
  });
}
